const ClipboardData = 'clipboardData';

export class ClipboardUtility {
  static copy(text: string): Promise<boolean> {
    const copyPromise = new Promise<boolean>(resolve => {
      if (!navigator.clipboard) {
        ClipboardUtility.copyFallback(text, resolve);
        return;
      }
      try {
        navigator.clipboard.writeText(text);
        resolve(true);
      } catch (ex) {
        ClipboardUtility.handleCopyFailed(ex, resolve);
      }
    });
    return copyPromise;
  }

  private static copyFallback(text: string, resolve: (value: boolean) => void) {
    if (window[ClipboardData] && window[ClipboardData].setData) {
      // IE specific code path to prevent textarea being shown while dialog is visible.
      try {
        window[ClipboardData].setData('Text', text);
        resolve(true);
        return;
      } catch (ex) {
        ClipboardUtility.handleCopyFailed(ex, resolve);
        return;
      }
    } else if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
      const textarea = document.createElement('textarea');
      textarea.innerText = text;
      textarea.style.position = 'fixed';
      textarea.style.width = '0px';
      textarea.style.height = '0px';
      const outOfViewPosition = '-99999px';
      textarea.style.top = outOfViewPosition;
      textarea.style.left = outOfViewPosition;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy'); // Security exception may be thrown by some browsers.
        resolve(true);
        return;
      } catch (ex) {
        ClipboardUtility.handleCopyFailed(ex, resolve);
        return;
      } finally {
        textarea.parentElement.removeChild(textarea);
      }
    }
    ClipboardUtility.handleCopyFailed(new Error('failed to copy to clipboard, no solution was applied'), resolve);
    return;
  }

  private static handleCopyFailed(ex: Error, resolve: (value: boolean) => void) {
    console.log('Copy to clipboard failed.', ex);
    resolve(false);
  }
}
